import { PropsWithChildren } from 'react';
import styles from './Panel.module.css';
import classNames from 'classnames';
import { HasStyle } from '~/types/HasStyle';

type Props = PropsWithChildren &
  HasStyle & {
    variant?: 'default' | 'error' | 'informative';
    size?: 'default' | 'sm';
    disabled?: boolean;
    rounded?: boolean;
  };

export function Panel({ children, disabled, style, variant = 'default', size = 'default', rounded = false }: Props) {
  return (
    <div
      className={classNames(styles.panel, styles[`variant-${variant}`], styles[`size-${size}`], {
        [styles.disabled]: disabled,
        [styles.rounded]: rounded,
      })}
      style={style}
    >
      {children}
    </div>
  );
}
